<div #carousel class="carousel">
    <ng-content></ng-content>
</div>
<div class="pagination">
    <div class="page" *ngFor="let page of numberOfCarouselItems" [class.page-active]="page == curentCarouselItem"
        (click)="goTo(page)"></div>
</div>